import { useEffect } from 'react';

import { stopBraze } from 'app/shared/utils/braze';
import { useCookiebotConsent } from 'app/shared/utils/useCookiebotConsent';

// Runs on every page, not only the ones using withBraze, so Braze's data is
// removed even if consent was withdrawn somewhere Braze wasn't running
export const useBrazeConsentCleanup = () => {
  const { consentReady, marketingConsent } = useCookiebotConsent();

  useEffect(() => {
    if (consentReady && !marketingConsent) {
      stopBraze();
    }
  }, [consentReady, marketingConsent]);
};
